import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ImportCompanyVM } from '../../../../components/crm/companies/pages/companies/companies.model';
import { ImportDocumentsService } from '../../../../components/import-documents/import-documents.service';
import { catchError } from 'rxjs';
import { Result } from '../../../model/response.model';
import { ActivityTabService } from '../../../../components/crm/companies/pages/company-info-tabs/activity-tab/activity-tab.service';
import { StorageService } from '../../../services/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-common-import-tab',
  templateUrl: './common-import-tab.component.html',
  styleUrls: ['./common-import-tab.component.scss']
})
export class CommonImportTabComponent implements OnInit , OnDestroy{
  @Input() data: any ={};
  file: File[];
  hideErrordiv: boolean = false;
  errorMessage: boolean = false;
  basePath = "../../../../assets/templete-file/";
  fileBaseName = "SampleCompanyImport";
  importCompanyVM = new ImportCompanyVM();
  progress: number = 0;
  hideProgressbar: boolean = false;
  base64OfFile: any;
  percentDone: number = 0;
  interval: any;
  buttonDisabled: boolean = false;
  headerText:string;
  dataBlank:boolean=false;
  errorMessageSupported: boolean = false;
  titles = ['Inventory','Part','OEMExcess','VendorParts','Consignment',];
  checkingValidateFile:boolean = false
constructor(public importDocumentsService: ImportDocumentsService,
  public activityTabService : ActivityTabService,
   public storageService: StorageService,
   private router: Router,
){
}
  ngOnInit(): void {
  }
  get fileName(): string {
    return `${this.data?.importData?.sourcePath??this.fileBaseName}.xlsx`;
  }
  
  get sourcePath(): string {
    return `${this.basePath}${this.fileName}`;
  }
  upload(event) {
    if (event.target.files && event.target.files.length > 0) {
      this.progress = 0;
      this.readThis(event.target);
      this.file = event.target.files;
      this.errorMessageSupported = false;
      this.data.importData.errorMessageSupported = false;
      this.hideProgressbar = true;
      this.data.importData.uploadSuccess = true;
    }
  }

  readThis(inputValue: any): void {
    var file: File = inputValue.files[0];
    this.data.importData.fileName = file.name;
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.base64OfFile = myReader.result;
      this.data.importData.file = this.base64OfFile;
      this.checkingListAvailable(myReader.result)
      if (this.data?.importData?.mappingTemplateId || this.data?.importData?.mappingTemplateId) {
        this.checkingValidateFiles();
      }
    };
    myReader.readAsDataURL(file);
  }

  hideUploadingdiv() {
    this.file = [];
    this.hideErrordiv = true;
    this.hideProgressbar = false;
    clearInterval(this.interval);
  }
  checkingValidateFiles() {
    let data;
    if (this.data?.importData?.mappingTemplateId == ""  || this.base64OfFile == '') {
    //  this.fileNotMatchError = true;
    }
     else {
      data = { file: this.base64OfFile, templateId: this.data?.importData?.mappingTemplateId  };
      this.importDocumentsService.validateFile(data)
        .pipe(
          catchError(async (err) => {
            console.error('Error validating template:', err);
            this.errorMessageSupported = true;
            this.data.importData.errorMessageSupported = true;
            this.headerText = 'Error! File upload is incompatible with the selected template.';
            this.data.importData.fileNotMatchError = true;
            return null;
          })
        )
        .subscribe((res:Result) => {
          if (res) {
            if(res?.isSuccess){
              this.data.importData.fileNotMatchError = false;
              if (this.headerText === 'Error! File upload is incompatible with the selected template.') {
                this.headerText = '';
                this.errorMessageSupported = false;
                this.data.importData.errorMessageSupported = false;
              }
            }
            else {
              this.data.importData.fileNotMatchError = true;
              this.errorMessageSupported = true;
              this.data.importData.errorMessageSupported = true;
              this.headerText = res.message || 'Error! File upload is incompatible with the selected template.';
            }
          }
        });
    }
  }
  checkingListAvailable(base64OfFile) {
    let data = { file: base64OfFile, sourceId: this.data?.sourceId ?? 1 }
    this.errorMessageSupported = false;
    this.data.importData.errorMessageSupported = false;
    this.headerText = '';
    this.importDocumentsService.validateFileHasData(data).pipe(
      catchError(async (err) => {
        console.error('Error validating file data:', err);
        this.errorMessageSupported = true;
        this.data.importData.errorMessageSupported = true;
        this.headerText = 'Error! Unsupported file type.';
        this.buttonDisabled = true;
        this.data.importData.buttonDisabled = true;
        return null;
      })
    )
      .subscribe((res: Result) => {
        if (res) {
          if (res?.isSuccess) {
            if (res.message === "Error!! No record available in imported file.") {
              this.data.importData.emptyFile = true;
              this.dataBlank = true;
              this.buttonDisabled = true;
              this.data.importData.buttonDisabled = true;
              this.errorMessageSupported = true;
              this.data.importData.errorMessageSupported = true;
              this.headerText = res.message;
            } else if (res.message === "File invalid. Headers do not match the target headers.") {
              this.headerText = res.message;
              this.data.importData.headerValue = true;
              this.buttonDisabled = true;
              this.data.importData.buttonDisabled = true;
              this.errorMessageSupported = true;
              this.data.importData.errorMessageSupported = true;
            }
            else {
              this.data.importData.headerValue = false;
              this.dataBlank = false;
              this.buttonDisabled = false;
              this.data.importData.buttonDisabled = false;
              this.data.importData.emptyFile = false;
              this.data.importData.fileNotMatchError = this.checkingValidateFile = false;
              this.errorMessageSupported = false;
              this.data.importData.errorMessageSupported = false;
              this.headerText = '';
              this.importDocumentsService.fileName.next(this.data?.importData?.fileName);
            }
          }
          else if (!res?.isSuccess) {
            this.errorMessageSupported = true;
            this.data.importData.errorMessageSupported = true;
            this.headerText = res.message || 'Error! Unsupported file type.';
            this.buttonDisabled = true;
            this.data.importData.buttonDisabled = true;
          }
        }
      });
  }
  
  handleError(err: any) {
    console.error('Error:', err);
    this.data.importData.fileNotMatchError = true;
    this.errorMessageSupported = true;
    this.data.importData.errorMessageSupported = true;
    this.headerText = 'Error! Validation failed.';
  }

  showuploadedfile() {
    this.hideErrordiv = false;
  }

  newImport() {
    this.data.importData.headerValue = false;
    this.data.importData.uploadSuccess = false;
    this.file = [];
    this.data.importData.fileNotMatchError = false;
    this.dataBlank = false;
    this.base64OfFile=''
    this.data.importData.file  = null;
    this.errorMessageSupported = false;
    this.data.importData.errorMessageSupported = false;
    this.headerText = '';
    this.buttonDisabled = false;
    this.data.importData.buttonDisabled = false;
  }

  showDescription(){
    this.data.importData.templateDescription = this.data?.importData?.mappingTemplateList?.find(a => a?.id == this.data?.importData?.mappingTemplateId)?.description;

  }
  updateList(){
    this.importDocumentsService.getImportDropDownList().subscribe(res => {
      if(!res?.isSuccess)return
      let list = res?.response
      const urlSegment:any = this.router?.url?.split('/').pop();
      switch(urlSegment){
        case this.titles[0]:
          this.data.importData.mappingTemplateList = list?.inventoryTemplateList;
        break;
        case this.titles[1]:
          this.data.importData.mappingTemplateList = list?.partTemplateList;
        break;
        case this.titles[2]:
          this.data.importData.mappingTemplateList = list?.oemExcessTemplateList;
        break;
        case this.titles[3]:
          this.data.importData.mappingTemplateList = list?.vendorPartsTemplateList;
        break;
        case this.titles[4]:
          this.data.importData.mappingTemplateList = list?.consignmentTemplateList;
        break;
      }
    })

  }
  selectmappingTemplateId(event){
    this.data.importData.mappingTemplateId=event;
    if(event == ''){
      if(this.data.importData.fileNotMatchError && this.base64OfFile && !this.checkingValidateFile){
        this.data.importData.fileNotMatchError = false;
      }else if(this.data?.templateData?.templateId){
        this.data.templateData = {}
        this.data.templateData.selectedOption = '1'
      }
  
    }
  }
  selectedLabel(event){
    this.data.importData.mappingTemplateName = event
  }
  getContactList(id){
    if (id == '') {
      this.data.importData.contactId = '';
      this.data.importData.contactList = this.storageService.retrieve('CONTACT_LIST');
      return
    }
    this.activityTabService.getContactList(id).subscribe((res) => {
      if (res.isSuccess) {
        this.data.importData.contactId = '';
        this.data.importData.contactList = res?.response?.contactList
      }
    })
  }
  ngOnDestroy() {
  }
}
